module.exports = __webpack_public_path__ + "static/konfor-web-a485d623c473efeab617364cf705ab54.jpg";